import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import LoaderContainer from '../../../shared/components/loader/LoaderContainer';
import { getSurveyWithResponse, postAnswers } from '../../survey/data/SurveyService';
import useSurveyContext from '../../survey/store/UseSurveyContext';
import useResultContext from '../store/UseResultContext';
import { Result } from '../types';

const ResultHandler = () => {
  const { t } = useTranslation();
  const { activationCode, resultCode } = useParams();
  const { updateQuestionAnswers, setBackupQuestionAnswers, updateSurvey, updateActivationCode } = useSurveyContext();
  const { updateInitialResult } = useResultContext();
  const navigator = useNavigate();

  useEffect(() => {
    if (activationCode && resultCode) {
      const fetchResult = async () => {
        const processedActivationCode = activationCode === 'null' ? null : activationCode;
        const language = localStorage.getItem('i18nextLng') ?? 'nl';

        const { answers, survey } = await getSurveyWithResponse(processedActivationCode, resultCode, language);
        updateQuestionAnswers(answers);
        setBackupQuestionAnswers(answers);
        updateSurvey(survey);
        updateActivationCode(processedActivationCode);

        const result = await postAnswers(answers, processedActivationCode, false);
        // @ts-ignore
        const { data } = result;
        updateInitialResult(data as Result);

        navigator('/dashboard');
      };

      fetchResult();
    }

    return () => {};
  }, [activationCode, resultCode]);

  if (!activationCode || !resultCode) {
    return (
      <div>
        <h1>Invalid result url</h1>
      </div>
    );
  }

  return <LoaderContainer text={t('survey.loading-results')} />;
};

export default ResultHandler;
